export default "__VITE_PUBLIC_ASSET__f695f79f__"